import {FileInfo} from './file-info';
import {FileType} from './file-type';

export class ExtFileInfo extends FileInfo {

  constructor(
    public id: number,
    public fileName: string,
    public type: FileType,
    public order: number,
    public file: File,
    public year: number) {
    super(id, fileName, type, order, year);
  }

  static fromFileInfo(fileInfo: FileInfo): ExtFileInfo {
    return new ExtFileInfo(fileInfo.id, fileInfo.fileName, fileInfo.type, fileInfo.order, null, fileInfo.year);
  }

  static getExtFileInfo(fileInfo: FileInfo[]): ExtFileInfo[] {
    const files: ExtFileInfo[] = [];
    if (fileInfo) {
      for (const file of fileInfo) {
        if (file) {
          files.push(ExtFileInfo.fromFileInfo(file));
        }
      }
    }
    return files;
  }

  static getNewFiles(fileInfos: ExtFileInfo[]): File[] {
    const files: File[] = [];
    for (const fileInfo of fileInfos) {
      if (fileInfo.file) {
        files.push(fileInfo.file);
      }
    }
    return files;
  }

  static toFileInfo(fileInfo: ExtFileInfo[]): FileInfo[] {
    const files: FileInfo[] = [];
    if (fileInfo) {
      for (const file of fileInfo) {
        files.push(new FileInfo(file.id, file.fileName, file.type, file.order, file.year));
      }
    }
    return files;
  }

}
